module.exports = __webpack_public_path__ + "static_pc/img/teach.02c6577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/teach.png
// module id = pT/0
// module chunks = 1